import lodash from 'lodash';
import mongoose from 'mongoose';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
    TableContainer,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Tooltip,
    withStyles,
    Icon,
    IconButton,
    TablePagination,
} from '@material-ui/core';
import { teal as colorTeal, pink as colorPink } from '@material-ui/core/colors';
import { Row, Col } from 'antd';
import Moment from 'react-moment';
import { table_styles } from '../../../../components/TableStyles';
import TableLoader from '../../../../components/table/TableLoader';
import TableNoData from '../../../../components/table/TableNoData';
import PaymentApprovalDetails from './paymentApproval/PaymentApprovalDetails';
import {
    VIEW_PAYMENT_APPROVAL_URL,
    SET_LEAD_PAYMENT_APPROVAL_DATA,
    GET_LEAD_PAYMENT_APPROVAL_DATA,
    GET_LEAD_PAYMENT_APPROVAL_DETAILS_DATA,
    SAVE_LEAD_PAYMENT_APPROVAL_DETAILS_DATA,
} from '../constants';
import { SET_MODAL_WINDOW_DATA } from '../../../App/redux/constants/modalWindow.constants';
import { leadFinanceSchema } from '../schemas/lead_finance.schema';

const tableCols = [
    { content: '#', width: '1%', align: 'center' },
    { content: 'Date', width: '10%', align: 'center' },
    { content: 'VRM', width: '10%', align: 'center' },
    { content: 'Bike', align: 'left' },
    { content: 'Approval', align: 'center' },
    { content: 'Year', width: '5%', align: 'center' },
    { content: 'Mileage', width: '5%', align: 'center' },
    { content: 'CC', width: '5%', align: 'center' },
    { content: 'Valuation', width: '5%', align: 'center' },
    { content: 'Division', width: '5%', align: 'center' },
    {
        content: <Tooltip title="Actions" placement="top">
            <div style={{ marginTop: '5px' }}>
                <Icon fontSize="small">flash_on</Icon>
            </div>
        </Tooltip>,
        width: '5%',
        align: 'center',
    },
];

class LeadsTable extends Component {
    componentDidMount() {
        this.refreshData(true);
    }

    refreshData = lodash.debounce((isCount) => {
        const { dispatch } = this.props;

        dispatch({ type: GET_LEAD_PAYMENT_APPROVAL_DATA, isCount });
    }, 500, { leading: true, trailing: false });

    handleChangePage = (event, page) => {
        const { dispatch, pagination } = this.props;

        dispatch({
            type: SET_LEAD_PAYMENT_APPROVAL_DATA,
            payload: {
                'pagination.page': page,
                'pagination.offset': page * pagination.rpp,
            },
            refreshPaths: ['pagination'],
        });

        this.refreshData();
    };

    handleChangeRpp = (event) => {
        const { dispatch } = this.props;
        const rpp = event.target.value;

        dispatch({
            type: SET_LEAD_PAYMENT_APPROVAL_DATA,
            payload: {
                'pagination.rpp': rpp,
            },
            refreshPaths: ['pagination'],
        });

        this.refreshData();
    };

    handleClickOpenPad = (leadId) => {
        const { dispatch } = this.props;
        const dataModel = mongoose.Document({}, leadFinanceSchema);

        dispatch({
            type: SET_LEAD_PAYMENT_APPROVAL_DATA,
            payload: {
                'approvalDetails.isLoading': true,
                'approvalDetails.$isNew': false,
                'approvalDetails.dataModel': dataModel,
            },
        });

        dispatch({
            type: SET_MODAL_WINDOW_DATA,
            payload: {
                isLoading: true,
                isOpen: true,
                maxWidth: 'lg',
                onSave: () => {
                    dispatch({
                        type: SAVE_LEAD_PAYMENT_APPROVAL_DETAILS_DATA,
                        dataModel,
                        op: 'Update',
                        finId: dataModel._id,
                        sourceScreen: VIEW_PAYMENT_APPROVAL_URL,
                    });
                },
                content: {
                    header: 'Payments Details',
                    body: <PaymentApprovalDetails sourceScreen={VIEW_PAYMENT_APPROVAL_URL} />,
                },
            },
            ignoreValueAsFn: true,
        });

        dispatch({
            type: GET_LEAD_PAYMENT_APPROVAL_DETAILS_DATA,
            leadId,
            sourceScreen: VIEW_PAYMENT_APPROVAL_URL,
        });
    }

    buildRow = (lead, leadIdx) => {
        const { pagination, leadProfileAccess } = this.props;
        const { created_date, ref_bike_lead: bike, lead_finance: fin } = lead;
        const { vrm } = bike;

        const brand = lodash.get(bike, 'ref_bike_brand.name');
        const model = lodash.get(bike, 'ref_bike_model.name') || lodash.get(bike, 'unmaped_data.bike_model');
        const variation = lodash.get(bike, 'ref_bike_model.model_variation') || '';
        const variant = lodash.get(bike, 'ref_bike_variant.year') || lodash.get(bike, 'unmaped_data.bike_year') || '-';
        const cc = lodash.get(bike, 'unmaped_data.bike_model.cc') || lodash.get(bike, 'unmaped_data.bike_cc') || '-';
        const valuation = lodash.isArray(lead.valuations) && !lodash.isEmpty(lead.valuations) ? lead.valuations[lead.valuations.length - 1].valuation : '-';
        const division = lodash.get(lead, 'ref_lead_source.abbr');
        const purchasingApproved = lodash.get(fin, 'bought_info.purchasing_team_approval.value');
        const transportApproved = lodash.get(fin, 'bought_info.transport_team_approval.value');
        const accountsApproved = lodash.get(fin, 'bought_info.accounts_team_approval.value');
        let bikeName = 'Unknown';

        if (model) {
            bikeName = `${brand} ${model} ${variation}`;
        } else if (brand) {
            bikeName = brand;
        }

        const leadProfileLink = (
            <Tooltip title="Open Lead Details" placement="top">
                <span>
                    <IconButton
                        color="primary"
                        aria-label="Open Lead Profile"
                        style={{ padding: 5 }}
                    >
                        <Link style={{ lineHeight: '20px' }} to={{ pathname: `/Leads/Lead_profile/${lead._id}` }}>
                            <Icon fontSize="small" color="primary">info_outlined</Icon>
                        </Link>
                    </IconButton>
                </span>
            </Tooltip>
        );

        return (
            <TableRow key={lead._id}>
                <TableCell align={tableCols[0].align}>
                    <span>{pagination.page * pagination.rpp + leadIdx + 1}</span>
                </TableCell>
                <TableCell align={tableCols[1].align}>
                    <span>
                        <Tooltip title={<Moment format="D-MM-YYYY HH:mm">{created_date}</Moment>} placement="top">
                            <Moment format="D MMM HH:mm">{created_date}</Moment>
                        </Tooltip>
                    </span>
                </TableCell>
                <TableCell align={tableCols[2].align}>
                    <span>
                        { vrm || '-' }
                    </span>
                </TableCell>
                <TableCell align={tableCols[3].align}>
                    <span>
                        { bikeName }
                    </span>
                </TableCell>
                <TableCell align={tableCols[4].align}>
                    <div style={{ display: 'inline-flex' }}>
                        <Tooltip title={`Purchasing Approved: ${purchasingApproved === true ? 'YES' : 'NO'}`} placement="top">
                            <IconButton
                                color="primary"
                                aria-label="Approval Details"
                                style={{ padding: 5 }}
                            >
                                <Icon
                                    fontSize="small"
                                    style={{ color: purchasingApproved === true ? colorTeal[700] : colorPink[500] }}
                                >
                                    shopping_cart_checkout
                                </Icon>
                            </IconButton>
                        </Tooltip>
                        <Tooltip title={`Transport Approved: ${transportApproved === true ? 'YES' : 'NO'}`} placement="top">
                            <IconButton
                                color="primary"
                                aria-label="Approval Details"
                                style={{ padding: 5 }}
                            >
                                <Icon
                                    fontSize="small"
                                    style={{ color: transportApproved === true ? colorTeal[700] : colorPink[500] }}
                                >
                                    bike_scooter
                                </Icon>
                            </IconButton>
                        </Tooltip>
                        <Tooltip title={`Accounts Approved: ${accountsApproved === true ? 'YES' : 'NO'}`} placement="top">
                            <IconButton
                                color="primary"
                                aria-label="Approval Details"
                                style={{ padding: 5 }}
                            >
                                <Icon
                                    fontSize="small"
                                    style={{ color: accountsApproved === true ? colorTeal[700] : colorPink[500] }}
                                >
                                    account_circle
                                </Icon>
                            </IconButton>
                        </Tooltip>
                    </div>
                </TableCell>
                <TableCell align={tableCols[5].align}>
                    <span>
                        { variant }
                    </span>
                </TableCell>
                <TableCell align={tableCols[6].align}>
                    <span>
                        { bike.mileage || '-' }
                    </span>
                </TableCell>
                <TableCell align={tableCols[7].align}>
                    <span>
                        { cc }
                    </span>
                </TableCell>
                <TableCell align={tableCols[8].align}>
                    <span>
                        { valuation }
                    </span>
                </TableCell>
                <TableCell align={tableCols[9].align}>
                    <span>
                        { division }
                    </span>
                </TableCell>
                <TableCell align={tableCols[10].align}>
                    <div style={{ display: 'inline-flex' }}>
                        <Tooltip title="Open Payments Approval Details" placement="top">
                            <IconButton
                                color="primary"
                                aria-label="Approval Details"
                                style={{ padding: 5 }}
                                onClick={() => this.handleClickOpenPad(lead._id)}
                            >
                                <Icon fontSize="small" style={{ color: colorTeal[600] }}>payments</Icon>
                            </IconButton>
                        </Tooltip>
                        {
                            leadProfileAccess && leadProfileLink
                        }
                    </div>
                </TableCell>
            </TableRow>
        );
    }

    render() {
        const {
            classes,
            data,
            dataCount,
            pagination,
            isLoading,
        } = this.props;

        return (
            <Row>
                <Col span={24}>
                    <TableContainer>
                        <Table className={`${classes.table} sbf-table`}>
                            <TableHead>
                                <TableRow>
                                    {
                                        tableCols.map((title, index) => (
                                            <TableCell
                                                // eslint-disable-next-line react/no-array-index-key
                                                key={index}
                                                align={title.align}
                                                style={{
                                                    width: [title.width],
                                                }}
                                            >
                                                {title.content}
                                            </TableCell>
                                        ))
                                    }
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    !isLoading && lodash.isEmpty(data) && <TableNoData colSpan={tableCols.length} />
                                }
                                {
                                    isLoading ? <TableLoader colSpan={tableCols.length} /> : data.map(this.buildRow)
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={pagination.rppOptions}
                        component="div"
                        count={dataCount}
                        rowsPerPage={pagination.rpp}
                        page={pagination.page}
                        backIconButtonProps={{ 'aria-label': 'Previous Page' }}
                        nextIconButtonProps={{ 'aria-label': 'Next Page' }}
                        onPageChange={this.handleChangePage}
                        onRowsPerPageChange={this.handleChangeRpp}
                    />
                </Col>
            </Row>
        );
    }
}

const mapStateToProps = (state) => {
    const {
        isLoading,
        data,
        dataCount,
        pagination,
    } = state.Leads.LeadPaymentApproval;

    return {
        isLoading, data, dataCount, pagination,
    };
};

export default connect(mapStateToProps)(withStyles(table_styles)(LeadsTable));



// WEBPACK FOOTER //
// ./src/modules/Leads/LeadPaymentApproval/components/LeadsTable.js